const CollectionProductCount = (props) => {
  const { collection } = props;
  if (collection.productCount === 1) {
    return `1 product result showing based on filter.`;
  }
  return `${collection.productCount} product result showing based on filter.`;
};

export default CollectionProductCount;
